module.exports = __webpack_public_path__ + "static/media/career-compass-logo.dadf209b.jpg";